/** Where the image is shown — picks the smallest suitable stored variant. */
export const EVENT_IMAGE_SLOT = {
  /** Chat list / pending rows (~56px) */
  THUMBNAIL: 'thumbnail',
  /** Conversation header (~48px) */
  HEADER: 'header',
  /** Feed large-card thumb (~96px) */
  CARD: 'card',
  /** Hero banners (~256–300px display) */
  HERO: 'hero',
};

/**
 * Event artwork is stored as external CDN URLs (Ticketmaster, festival sources).
 * hero_image_url ≈ 16:9 ≥2000px; card_image_url ≈ 16:9 640–2000px (see ingestion).
 * Prefer card for small slots to avoid downloading hero resolution.
 */
export function getEventImageUrl(source, slot = EVENT_IMAGE_SLOT.CARD) {
  if (!source) return null;

  const hero =
    typeof source === 'string' ? null : (source.hero_image_url ?? source.heroImageUrl ?? null);
  const card =
    typeof source === 'string' ? null : (source.card_image_url ?? source.cardImageUrl ?? null);

  if (typeof source === 'string') {
    return source || null;
  }

  if (slot === EVENT_IMAGE_SLOT.HERO) {
    return hero || card || null;
  }

  return card || hero || null;
}

/** Layout dimensions (CSS px) for common event image slots — prevents CLS. */
export const EVENT_IMAGE_LAYOUT = {
  [EVENT_IMAGE_SLOT.THUMBNAIL]: { width: 56, height: 56 },
  [EVENT_IMAGE_SLOT.HEADER]: { width: 48, height: 48 },
  [EVENT_IMAGE_SLOT.CARD]: { width: 96, height: 96 },
  [EVENT_IMAGE_SLOT.HERO]: { width: 640, height: 256 },
  detailHero: { width: 640, height: 300 },
};
